// extracted by mini-css-extract-plugin
module.exports = {"forLLMs":"for-llms-styles-module--forLLMs--3dQs4","comparison":"for-llms-styles-module--comparison--12tGr","note":"for-llms-styles-module--note--6nDzx"};